module.exports = __webpack_public_path__ + "img/logo-siwf.be1d3dd.jpg";